var base = require('kiosk/users');

Vue.component('spark-kiosk-users', {
    mixins: [base],

    /**
     * The component's data.
     */
    data() {
        return {
            plans: [],

            searchForm: new SparkForm({
                query: ''
            }),

            searching: false,
            noSearchResults: false,
            searchResults: [],

            showingUserProfile: false,
            userToDelete: -1,
        };
    },


    methods: {
        /**
         * Confirm the delete operation.
         */
        confirmDelete(user) {
            this.userToDelete = user.id;
            $('#modal-confirm-delete').modal('show');
        },

        deleteUser() {
            console.log('deleting user: ' + this.userToDelete);
            axios.delete('/kiosk/users/delete/' + this.userToDelete)
                .then(() => {
                    $('#modal-confirm-delete').modal('hide');
                    this.search();
                    this.userToDelete = -1;
                });
        }
    }
});
